import script from "./cat24SideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./cat24SideBar.vue?vue&type=script&setup=true&lang=js"

import "./cat24SideBar.vue?vue&type=style&index=0&id=497ef991&scoped=true&lang=css"

import exportComponent from "/Users/craighopkins/Documents/GitHub/Cat24AdministrationPortalv2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-497ef991"]])

export default __exports__